import * as types from '../../action-types';

const setAdyenV2PlaceOrderDataActionObject = (placeOrderData, billingAddress) => ({
  type: types.SET_ADYEN_V2_PLACE_ORDER_DATA,
  placeOrderData,
  billingAddress,
});

const setAdyenV2PlaceOrderData = (placeOrderData, billingAddress) => (dispatch) => {
  dispatch(setAdyenV2PlaceOrderDataActionObject(placeOrderData, billingAddress));
};

export default setAdyenV2PlaceOrderData;
